const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/user/$userId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// Legacy User Profile
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/user/$userId/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Profile",
      description: "Page title"
    })
  }
});